import axios from 'axios';

// Configuration pour routes publiques/optionnelles
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Create Axios instance for public routes
const publicApiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Permet l'envoi/réception de cookies httpOnly
});

// Intercepteur pour ajouter tenantId en query param SANS authentification requise
// Le token JWT est maintenant envoyé automatiquement via cookie httpOnly
publicApiClient.interceptors.request.use(
  (config) => {
    // Si vous souhaitez toujours ajouter tenantId, faites-le ici à partir d'un autre stockage si besoin
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur plus permissif pour les erreurs (ne redirige pas vers login)
publicApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Log l'erreur mais ne redirige pas automatiquement
    if (error.response?.status === 401) {
      console.warn('Authentification échouée sur route publique:', error.response.data);
    }
    return Promise.reject(error);
  }
);

export default publicApiClient;
